import React from "react";

function CustomStepperNew({ currentStep = 0, tabs }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        minHeight: "100px",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      {tabs.map((tab, index) => {
        return (
          <div
            style={{
              position: "relative",
              display: "flex",
              zIndex: 1,
              width: tabs.length - 1 === index ? "5%" : "25%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  ...styles.round,
                  backgroundColor:
                    currentStep >= tab.key ? "#FFB44C" : "#FDFDFD",
                  color: currentStep >= tab.key ? "#FFFFFF" : "#C2C1CA",
                  border: "1px solid rgba(155, 174, 210, 0.55)",
                }}
              >
                {tab.key}
              </div>
              <p
                style={{
                  ...styles.titles,
                  color: currentStep >= tab.key ? "#000000" : "#6C7290",
                  width: "50px",
                  marginTop: 5,
                }}
              >
                {tab.name}
              </p>
            </div>

            {index !== tabs.length - 1 && (
              <div
                style={{
                  height: 1,
                  border:
                    currentStep >= tab.key
                      ? "0.2px dashed #6C72FF"
                      : "0.2px dashed #B6B9FF",
                  width: "100%",
                  position: "absolute",
                  top: "22px",
                  left: 5,
                  zIndex: -1,
                }}
              />
            )}
          </div>
        );
      })}

      {/* <div style={{ display: "flex" }}>
          <div style={{ position: "relative" }}>
            <div
              style={{
                ...styles.round,
                backgroundColor: currentStep >= 2 ? "#FFB44C" : "#FDFDFD",
              }}
            >
              2
            </div>
            <p
              style={{
                ...styles.titles,
                position: "absolute",
                top: 50,
                color: currentStep >= 3 ? "#000000" : "#6C7290",
              }}
            >
              Business Details
            </p>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ position: "relative" }}>
            <div
              style={{
                ...styles.round,
                backgroundColor: currentStep >= 3 ? "#FFB44C" : "#FDFDFD",
              }}
            >
              3
            </div>
            <p
              style={{
                ...styles.titles,
                position: "absolute",
                top: 50,
                left: -15,
                color: currentStep >= 4 ? "#000000" : "#6C7290",
              }}
            >
              Documents
            </p>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ position: "relative" }}>
            <div
              style={{
                ...styles.round,
                backgroundColor: currentStep >= 4 ? "#FFB44C" : "#FDFDFD",
              }}
            >
              4
            </div>
            <p
              style={{
                ...styles.titles,
                position: "absolute",
                top: 50,
                left: 5,
                color: currentStep >= 5 ? "#000000" : "#6C7290",
              }}
            >
              VKYC
            </p>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ position: "relative" }}>
            <div
              style={{
                ...styles.round,
                backgroundColor: currentStep >= 5 ? "#FFB44C" : "#FDFDFD",
              }}
            >
              5
            </div>
            <p
              style={{
                ...styles.titles,
                position: "absolute",
                top: 50,
                left: 5,
                color: currentStep >= 6 ? "#000000" : "#6C7290",
              }}
            >
              Service Type
            </p>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ position: "relative" }}>
            <div
              style={{
                ...styles.round,
                backgroundColor: currentStep >= 6 ? "#FFB44C" : "#FDFDFD",
              }}
            >
              6
            </div>
            <p
              style={{
                ...styles.titles,
                position: "absolute",
                top: 50,
                color: currentStep >= 6 ? "#000000" : "#6C7290",
              }}
            >
              Bank Details
            </p>
          </div>
        </div> */}
    </div>
  );
}

export default CustomStepperNew;
const styles = {
  round: {
    height: "42px",
    width: "42px",
    borderRadius: "50%",
    background: "#FDFDFD",
    border: "1px solid rgba(155, 174, 210, 0.55)",
    padding: "8px 0 0 16px",
  },
  line: {
    height: "1px",
    width: "100%",
    border: "1px dashed #B6B9FF",
    marginTop: "20px",
    textAlign: "center",
  },

  titles: {
    fontWeight: "400",
    fontSize: "14px",
    color: "#6C7290",
    textAlign: "center",

    // position: "absolute",
  },
};
